import { useTheme } from './context';

type Props = {
  className?: string;
  showLabel?: boolean;
};

export default function ThemeToggle({ className = '', showLabel = false }: Props) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const label = isDark ? 'Light' : 'Dark';

  return (
    <button
      type="button"
      data-testid="theme-toggle"
      onClick={toggleTheme}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`whitespace-nowrap flex items-center gap-1.5 text-sm text-texts hover:text-textp transition-colors ${className}`}
    >
      <i className={isDark ? 'ri-sun-line' : 'ri-moon-line'} />
      {showLabel && label}
    </button>
  );
}
